<script lang="ts" setup>
defineProps<{
  video: Video.Detail
}>()

const { scrollBottom } = useScrollState()

function goToComment() {
  const el = document.getElementById('comment')
  if (el) {
    window.scrollTo({
      top: el.offsetTop - 64,
      behavior: 'smooth'
    })
  }
}
</script>

<template>
  <div class="m-video-side-action">
    <div class="m-video-side-action-item">
      <m-like-action
        :resource-id="video.id"
        :resource-type="1"
        :like-status="video.like_status"
        type="like"
        vertical
      >
        <span class="text">
          {{ pipe.num(video.like_status.like.count) || '喜欢' }}
        </span>
      </m-like-action>
    </div>
    <div class="m-video-side-action-item">
      <m-like-action
        :resource-id="video.id"
        :resource-type="1"
        :like-status="video.like_status"
        type="dislike"
        vertical
      >
        <span class="text">
          {{ pipe.num(video.like_status.dislike.count) || '不喜欢' }}
        </span>
      </m-like-action>
    </div>
    <div class="m-video-side-action-item">
      <m-reward-action :resource-id="video.id" :resource-type="1" vertical>
        <span class="text">
          {{ pipe.num(video.reward_count) || '打赏' }}
        </span>
      </m-reward-action>
    </div>
    <div class="m-video-side-action-item">
      <m-favorite-action :resource-id="video.id" :resource-type="1" vertical>
        <span class="text">
          {{ pipe.num(video.favorite_count) || '收藏' }}
        </span>
      </m-favorite-action>
    </div>
    <div class="m-video-side-action-item" @click="goToComment">
      <m-icon icon="ni ni-comment" vertical>
        <span class="text">
          {{ pipe.num(video.comments?.floor_count) || '评论' }}
        </span>
      </m-icon>
    </div>
    <div class="m-video-side-action-item">
      <m-forward-action :resource-id="video.id" :resource-type="1" vertical>
        <span class="text">转发</span>
      </m-forward-action>
    </div>
    <div class="m-video-side-action-item">
      <m-report-action :resource-id="video.id" :resource-type="1" vertical>
        <span class="text">举报</span>
      </m-report-action>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.m-video-side-action {
  position: fixed;
  top: 92px;
  margin-left: -75px;
  color: #393939;
  &-item {
    padding: 8px;
    width: 64px;
    height: 64px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .m-icon {
      font-size: 24px;
      cursor: pointer;
    }
    .text {
      margin-top: 8px;
      font-size: 12px;
    }
  }
}
</style>
